<template>
  <div>
    <BasicModal
      :isShowModal="isShowModal"
      @close-modal="handleToggleModal"
      title="프로필 보기"
    >
      <div class="popupViewProfile" style="padding-bottom: 60px;">
        <div class="popupViewProfileCardImage">
          <figure class="networkSearchItemImage">
            <img src="/images/manager/matching/matching1.png" alt="미국 국기" />
          </figure>
          <div class="popupViewProfileCardImageText">
            <h3 class="popupViewProfileCardImageTitle">
              (주)행복을 만드는 사람들
            </h3>
            <h5 class="popupViewProfileCardImageDesc">032-222-3333</h5>
            <h5 class="popupViewProfileCardImageEmail">asdfsadf@naver.com</h5>
            <MainButton
              btnText="홈페이지"
              customFontSize="16px"
              width="116px"
              customHeight="32px"
            />
          </div>
        </div>

        <div>
          <h6 class="popupViewProfileHeadline">기업 정보</h6>
          <table class="popupViewProfileTable">
            <tbody>
              <tr>
                <td class="firstTd">업종</td>
                <td>제조업</td>
              </tr>
              <tr>
                <td class="firstTd">설립 연도</td>
                <td>2011</td>
              </tr>
              <tr>
                <td class="firstTd">기업 형태</td>
                <td>합자회사</td>
              </tr>
              <tr>
                <td class="firstTd">사원수</td>
                <td>235명</td>
              </tr>
              <tr>
                <td class="firstTd">매출 규모</td>
                <td>123억</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div>
          <h6 class="popupViewProfileHeadline">제품(서비스)</h6>
          <table class="popupViewProfileTable">
            <tbody>
              <tr>
                <td class="firstTd">제품(서비스)명</td>
                <td>기능성 노화예방 힐링크림</td>
              </tr>
              <tr>
                <td class="firstTd">제품(서비스) 설명</td>
                <td>
                  특수 재생물질을 포함한 주름개선 및 피부색 보완을 위한 기능성
                  화장품
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div>
          <h6 class="popupViewProfileHeadline">매치메이킹 희망분야</h6>
          <table class="popupViewProfileTable">
            <tbody>
              <tr>
                <td rowspan="2" class="headlineTd">1</td>
                <td class="firstTd">산업</td>
                <td>고령친화의약품 산업</td>
              </tr>
              <tr>
                <td class="firstTd">세부 분야</td>
                <td>정보통신기기, 의약품, 화장품, 식료품, 건강보조식품</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div style="margin-top: 12px;">
          <table class="popupViewProfileTable">
            <tbody>
              <tr>
                <td rowspan="2" class="headlineTd">2</td>
                <td class="firstTd">산업</td>
                <td>고령친화의약품 산업</td>
              </tr>
              <tr>
                <td class="firstTd">세부 분야</td>
                <td>정보통신기기, 의약품, 화장품, 식료품, 건강보조식품</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div style="margin-top: 12px;">
          <table class="popupViewProfileTable">
            <tbody>
              <tr>
                <td rowspan="2" class="headlineTd">3</td>
                <td class="firstTd">산업</td>
                <td>고령친화의약품 산업</td>
              </tr>
              <tr>
                <td class="firstTd">세부 분야</td>
                <td>정보통신기기, 의약품, 화장품, 식료품, 건강보조식품</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div style="margin-top: 12px;">
          <table class="popupViewProfileTable">
            <tbody>
              <tr>
                <td rowspan="2" class="headlineTd">4</td>
                <td class="firstTd">산업</td>
                <td>고령친화의약품 산업</td>
              </tr>
              <tr>
                <td class="firstTd">세부 분야</td>
                <td>정보통신기기, 의약품, 화장품, 식료품, 건강보조식품</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div>
          <h6 class="popupViewProfileHeadline">매치메이킹 희망활동</h6>
          <table class="popupViewProfileTable">
            <tbody>
              <tr>
                <td rowspan="2" class="headlineTd">1</td>
                <td class="firstTd">희망 분야</td>
                <td>마케팅</td>
              </tr>
              <tr>
                <td class="firstTd">세부 내용</td>
                <td>홍보하는 방법과 채널을 추천받고 싶습니다.</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div style="margin-top: 12px;">
          <table class="popupViewProfileTable">
            <tbody>
              <tr>
                <td rowspan="2" class="headlineTd">2</td>
                <td class="firstTd">희망 분야</td>
                <td>마케팅</td>
              </tr>
              <tr>
                <td class="firstTd">세부 내용</td>
                <td>홍보하는 방법과 채널을 추천받고 싶습니다.</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <template #footer>
        <MainButton btnText="닫기" width="191px" color="gray" />
      </template>
    </BasicModal>
  </div>
</template>

<script>
import MainButton from "../../components/button/MainButton.vue";
import BasicModal from "../../components/modal/BasicModal.vue";

export default {
  name: "PopUpViewProfile",
  components: { BasicModal, MainButton },

  props: {
    handleToggleModal: Function,
    isShowModal: Boolean,
  },
};
</script>
